import { render, staticRenderFns } from "./expected_student_files_list.vue?vue&type=template&id=7fa6c6ec&scoped=true&"
import script from "./expected_student_files_list.vue?vue&type=script&lang=ts&"
export * from "./expected_student_files_list.vue?vue&type=script&lang=ts&"
import style0 from "./expected_student_files_list.vue?vue&type=style&index=0&id=7fa6c6ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa6c6ec",
  null
  
)

export default component.exports